import { t, useI18n } from "@bookingcom/lingojs-react";
import useSearchFiltersController from "../../useSearchFiltersController";
import flights_web_budget_layover_airports_filters from "../../../../../utils/experiments/funnel/flights_web_budget_layover_airports_filters";

export const useAirportsFilterController = () => {
  const i18n = useI18n();
  const { airports } = useSearchFiltersController();

  const handleOnChange = (checked: boolean, value: string) => {
    flights_web_budget_layover_airports_filters.goals.interactedWithAirportsFilter();
    const currentIataCodes = airports.value.map((airport) => airport.iata);
    if (checked) {
      airports.set([...currentIataCodes, value]);
    } else {
      airports.set(currentIataCodes.filter((iata) => iata !== value));
    }
  };

  const handleSelectSingleOption = (value: string) => {
    airports.set([value]);
  };

  return {
    isFilterAvailable: !!airports.options,
    title: i18n.trans(t("flights_filters_airports_title")),
    resetLabel: i18n.trans(t("flights_filter_reset")),
    options: airports.options,
    showReset: airports.touched,
    onClickReset: () => {
      airports.reset();
    },
    value: airports.value,
    onChange: handleOnChange,
    onSelectSingleOption: (value: string) => {
      handleSelectSingleOption(value);
    }
  };
};
